export function filterAndPaginateCountries({
  countries,
  seek,
  pagination,
}: {
  countries: {
    id: number;
    code: string;
    iso_code: string;
    number: string;
    country: string;
  }[];
  seek: string;
  pagination: { pageIndex: number; pageSize: number };
}) {
  const filteredCountries = countries.filter((item) =>
    item.country.toLowerCase().startsWith(seek.toLowerCase()),
  );
  const paginatedCountries = paginateArray(filteredCountries, pagination.pageSize);
  return paginatedCountries[pagination.pageIndex] ?? [];
}

function paginateArray<T>(array: T[], pageSize: number): T[][] {
  const paginatedArray: T[][] = [];
  for (let i = 0; i < array.length; i += pageSize) {
    paginatedArray.push(array.slice(i, i + pageSize));
  }
  return paginatedArray;
}
